
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Die Therapie richtet sich nach der Ursache des Schnarchens. Bei einer leichten Schlafapnoe reicht es manchmal aus, den Lebensstil zu ändern. Genügt das nicht, können spezielle Schienen helfen, die im Mund getragen werden und den Unterkiefer samt Zunge vorverlagern. So soll der Atemweg erweitert werden. Eine andere bekannte Möglichkeit ist die CPAP-Therapie (Continuous Positive Airway Pressure), die bei ärztlicher Verordnung von der Krankenkasse bezahlt wird. `}<M mdxType="M">{`Das CPAP-Gerät leitet dabei Luft in eine relativ markante Nasenmaske, die über Nacht getragen wird.`}</M>{` Dank des Luftstroms bleiben die Atemwege offen, wodurch freier geatmet werden kann. So wird der Schlaf tiefer und die Folgeerkrankungen bleiben aus. `}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;